export default function parseIntOrNull(value: string | string[] | number | null | undefined): number | null {
  const parsedValue = parseInt(value as string, 10)
  return isNaN(parsedValue) ? null : parsedValue
}
